var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "fill-parent-container"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('div', {
    staticClass: "container-answer noselect",
    class: [_vm.isBig ? 'long-answer' : 'short-answer'],
    attrs: {
      "id": _vm.answerDomElementId
    }
  }, [_vm._l(_vm.splitWords, function (word, i) {
    return _c('span', {
      key: i,
      staticClass: "word"
    }, [_vm.splitWords.length > 1 && word.text === ' ' ? _c('span', {
      staticClass: "height-fix"
    }) : _vm._e(), _vm._l(word.text, function (letter, j) {
      return _c('span', {
        key: letter + word.startingIndex + j,
        class: _vm.getClass(word.text, word.startingIndex + j),
        attrs: {
          "aria-hidden": "true"
        },
        domProps: {
          "innerHTML": _vm._s(letter)
        }
      });
    })], 2);
  }), _c('span', {
    staticClass: "blinker"
  }, [_vm._v("_")])], 2), _vm.answerLocal && _vm.answerLocal.trim().length > 0 ? _c('done-button', {
    class: ['done-button', _vm.answerLocal ? '' : 'hidden'],
    attrs: {
      "on-click": _vm.done,
      "transition": _vm.innerTransition,
      "text": "Done"
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }